
/**
		Ахтунг! При внесении изменений стоит подумать о внесении аналогичных в text_input
	*/
import ctrlMixins from './_mixins.js';
import validationStuff from './../validationStuff.js';
import { getEmptyValueDisplay } from './../utils.js';
// @ts-ignore (визард собирается, а юарм - нет, и наоборот. Надо что-то делать)
import { ctrlParamsForAll } from './_common-stuff.ts';
import { UarmCtrlComponentMeta } from '@uarmSrc/types';

/** Это наше кастомное поле, т.е. vue не использует их в конфигурации компонента */
const meta: UarmCtrlComponentMeta = {
	title: 'Числовое поле',
	params: {
		defaultValue: {
			name: 'Значение по умолчанию',
			editType: 'input',
			tip: 'Применяется только в карточке и только при создании записи',
		},
		isRange: {
			name: 'Поиск по диапазону',
			editType: 'checkbox',
			tip: 'При фильтрации будет два поля',
			onlyForViewTypes: ['filter'],
		},
		validationRules: {
			name: 'Валидация',
			editType: 'validationRulesEditor_number',
		},
		isReadOnly: {
			name: 'Нередактируемое',
			editType: 'checkbox',
		},
		emptyValueDisplayProps: {
			name: 'Кастомный показ пустых значений',
			tip: 'Если проставить флаг "вкл", то поле с пустым значением будет либо скрыто целиком, либо, если указан текст-плейсхолдер, вместо пустой строки будет выведен этот текст',
			editType: 'emptyValueDisplayPropsEd',
		},
		...ctrlParamsForAll,
	},
}

export default {
	name: 'ctrl_number_input',
	meta,
	mixins: [
		ctrlMixins, // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		validationStuff.mixin,
	],
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		value: {
			default: '',
		},
		is_double: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			emptyValueDisplay: getEmptyValueDisplay(
				this.$props.is_new_record,
				this.$props.field_meta.ctrlParams,
				this.$props.value,
			),
		};
	},
};
